function toggleDesc() {
  const content = document.getElementById('desc-content');
  const toggle = document.getElementById('desc-toggle');
  const fade = document.getElementById('desc-fade');
  
  if (content.classList.contains('collapsed')) {
    content.style.maxHeight = 'none';
    content.style.overflow = 'visible';
    content.classList.remove('collapsed');
    toggle.textContent = toggle.dataset.textLess || 'Voir moins';
    fade.classList.add('hidden');
  } else {
    content.style.maxHeight = '433px';
    content.style.overflow = 'hidden';
    content.classList.add('collapsed');
    toggle.textContent = toggle.dataset.textMore || 'Voir plus';
    fade.classList.remove('hidden');
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const content = document.getElementById('desc-content');
  const toggle = document.getElementById('desc-toggle');
  const fade = document.getElementById('desc-fade');
  
  if (!content || !toggle || !fade) return;
  
  // Store translation texts
  toggle.dataset.textMore = toggle.textContent;
  toggle.dataset.textLess = toggle.dataset.textLess || 'Voir moins';
  
  content.style.lineHeight = '1.6';
  
  if (content.scrollHeight <= 433) {
    toggle.parentElement.style.display = 'none';
    fade.style.display = 'none';
    content.classList.remove('collapsed');
    content.style.maxHeight = 'none';
  }
});
